import { useExamEventDetails } from '@exam-center/exam-event-management';
import { useGetDipChipDeepLinkUrlLazyQuery } from '@exam-center/graphql';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useTimeGate } from '@exam-center/server-time';
import { Button, Tooltip } from '@shared/components';
import { WithPermission } from '@shared/permissions';
import { useSnackbar } from '@shared/snackbar';
import { dayjs } from '@shared/utils';
import { useMemo } from 'react';

import { IdCardIcon } from '../../components';

export default function DipChipDeepLinkButton() {
  const { examEvent } = useExamEventDetails();

  const examDayStart = useMemo(
    () => dayjs(examEvent.examStartedAt).startOf('day').toDate(),
    [examEvent.examStartedAt],
  );
  const thirtyMinAfterStart = useMemo(
    () => dayjs(examEvent.examStartedAt).add(30, 'minute').toDate(),
    [examEvent.examStartedAt],
  );

  const isOnOrAfterExamDate = useTimeGate(examDayStart);
  const isMoreThan30MinutesAfterExamStartTime = useTimeGate(thirtyMinAfterStart);

  const isBeforeExamDate = !isOnOrAfterExamDate;

  const [getDipChipDeepLinkUrl, { loading }] = useGetDipChipDeepLinkUrlLazyQuery();
  const { showSnackbar } = useSnackbar();

  async function handleDeepLinkClick() {
    await getDipChipDeepLinkUrl({
      variables: {
        getDipChipDeepLinkUrlInput: {
          examEventId: examEvent.id,
        },
      },
      onCompleted: (data) => {
        const deepLinkUrl = data.ecGetDipChipDeepLinkUrl?.deepLinkUrl;
        if (deepLinkUrl) {
          window.open(deepLinkUrl, '_blank');
        }
      },
      onError: () => {
        showSnackbar({
          message: 'เกิดข้อผิดพลาดในการเปิดโปรแกรม DipChip',
          variant: 'error',
        });
      },
    });
  }

  return (
    <WithPermission requiredPermission={APP_PERMISSIONS.PROCTORING.REGISTRATION.UPDATE}>
      <Tooltip
        title={
          isBeforeExamDate
            ? 'ลงทะเบียนได้เฉพาะวันสอบเท่านั้น'
            : isMoreThan30MinutesAfterExamStartTime
              ? 'ไม่สามารถลงทะเบียนได้\nเนื่องจากสิ้นสุดช่วงเวลาการลงทะเบียนแล้ว'
              : ''
        }
        arrow
        placement='left'
      >
        <Button
          sx={(theme) => ({
            display: 'none',
            gap: theme.spacing(2),
            [theme.breakpoints.up('desktop')]: {
              display: 'flex',
            },
            '&.Mui-disabled': {
              pointerEvents: 'auto',
              bgcolor: theme.palette.grey[100],
              ':hover': {
                borderColor: theme.palette.grey['300'],
              },
            },
          })}
          onClick={handleDeepLinkClick}
          loading={loading}
          disabled={isBeforeExamDate || isMoreThan30MinutesAfterExamStartTime}
        >
          <IdCardIcon />
          ลงทะเบียนผู้เข้าสอบ (Dip Chip)
        </Button>
      </Tooltip>
    </WithPermission>
  );
}
